// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var ToggleMandatory$ReactHooksTemplate = require("./ToggleMandatory.res.js");

function ShortTextEditor(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(ToggleMandatory$ReactHooksTemplate.make, {
                    mandatory: props.mandatory,
                    onMandatoryChange: props.onMandatoryChange
                  })
            });
}

var make = ShortTextEditor;

exports.make = make;
/* react/jsx-runtime Not a pure module */
